<app-page-header
  eyebrow="Микроскоп"
  title="Обяви"
  lead="Аналитична таблица на пазара: всяка обява с дни на пазара, отстъпка и отклонение спрямо хедоничния модел (над/подценена)."
/>

<app-market-notice />

<div class="filters-header">
  <span class="filters-heading">Филтриране на обявите</span>
  @if (hasActiveFilters()) {
    <button type="button" class="clear-filters-btn" (click)="resetFilters()">
      Изчисти филтрите ✕
    </button>
  }
</div>

<!-- Filters -->
<div class="filters card">
  <label class="field">
    Град
    <select [value]="city() ?? ''" (change)="setCity($any($event.target).value)">
      <option value="">Всички</option>
      @for (c of meta()?.cities; track c.id) {
        <option [value]="c.slug">{{ c.name }}</option>
      }
    </select>
  </label>
  <label class="field">
    Квартал
    <select
      [value]="neighborhoodId() ?? ''"
      (change)="neighborhoodId.set(toNum($any($event.target).value)); page.set(1)"
      [disabled]="!city()"
    >
      <option value="">Всички</option>
      @for (n of neighborhoods(); track n.id) {
        <option [value]="n.id">{{ n.name }}</option>
      }
    </select>
  </label>
  <label class="field">
    Тип сделка
    <select [value]="listingType() ?? ''" (change)="listingType.set(orU($any($event.target).value)); page.set(1)">
      <option value="">Всички</option>
      <option value="sale">Продажба</option>
      <option value="rent">Наем</option>
    </select>
  </label>
  <label class="field">
    Тип имот
    <select [value]="propertyType() ?? ''" (change)="propertyType.set(orU($any($event.target).value)); page.set(1)">
      <option value="">Всички</option>
      @for (t of propertyTypes; track t) {
        <option [value]="t">{{ typeBg[t] }}</option>
      }
    </select>
  </label>
  <label class="field">
    Строителство
    <select [value]="construction() ?? ''" (change)="construction.set(orU($any($event.target).value)); page.set(1)">
      <option value="">Всички</option>
      @for (c of constructions; track c) {
        <option [value]="c">{{ constructionBg[c] }}</option>
      }
    </select>
  </label>
  <label class="field">
    Статус
    <select [value]="status() ?? ''" (change)="status.set(orU($any($event.target).value)); page.set(1)">
      <option value="">Активен пазар</option>
      <option value="active">Активна</option>
      <option value="reduced">Намалена</option>
      <option value="removed">Свалена</option>
    </select>
  </label>
  <label class="field">
    Цена от (€)
    <input type="number" min="0" step="1000" [value]="minPrice() ?? ''" (input)="minPrice.set(toNum($any($event.target).value)); page.set(1)" />
  </label>
  <label class="field">
    Цена до (€)
    <input type="number" min="0" step="1000" [value]="maxPrice() ?? ''" (input)="maxPrice.set(toNum($any($event.target).value)); page.set(1)" />
  </label>
  <label class="field">
    Площ от (м²)
    <input type="number" min="0" [value]="minArea() ?? ''" (input)="minArea.set(toNum($any($event.target).value)); page.set(1)" />
  </label>
  <label class="field">
    Площ до (м²)
    <input type="number" min="0" [value]="maxArea() ?? ''" (input)="maxArea.set(toNum($any($event.target).value)); page.set(1)" />
  </label>
</div>

@if (result(); as r) {
  <p class="count">
    Намерени: <b>{{ r.total | bgInt }}</b> обяви · страница {{ r.page }} от {{ totalPages() }}
  </p>

  <div class="table-wrap">
    <table class="data-table">
      <thead>
        <tr>
          <th>Локация</th>
          <th>Имот</th>
          <th class="num sortable" (click)="sortBy('price')" [class.on]="sort() === 'price'">Офертна цена {{ arrow('price') }}</th>
          <th class="num sortable" (click)="sortBy('ppm2')" [class.on]="sort() === 'ppm2'">Офертна €/м² {{ arrow('ppm2') }}</th>
          <th class="num">Площ</th>
          <th class="num sortable" (click)="sortBy('dom')" [class.on]="sort() === 'dom'">DOM {{ arrow('dom') }}</th>
          <th class="num sortable" (click)="sortBy('discount')" [class.on]="sort() === 'discount'">Отстъпка {{ arrow('discount') }}</th>
          <th class="num sortable" (click)="sortBy('overpriced')" [class.on]="sort() === 'overpriced'">Δ модел {{ arrow('overpriced') }}</th>
          <th>Статус</th>
          <th class="num">Публикувана</th>
        </tr>
      </thead>
      <tbody>
        @for (l of r.rows; track l.id) {
          <tr>
            <td>
              <div class="loc-main">
                <span class="strong">{{ l.cityName }}</span>
                <span class="muted"> · {{ l.neighborhoodName }}</span>
              </div>
              @if (l.sourceUrl) {
                <a [href]="l.sourceUrl" target="_blank" rel="noopener" class="source-link" title="Преглед на обявата в {{ l.sourceId }}">
                  ↗ {{ l.sourceId }}
                </a>
              }
            </td>
            <td>
              <!-- Real sources often state no construction type, build year
                   or floor. Show the gap rather than an invented value. -->
              {{ typeBg[l.propertyType] }}
              @if (l.construction) {
                · {{ constructionBg[l.construction] }}
              }
              @if (l.buildYear) {
                · {{ l.buildYear }} г.
              }
              @if (l.floor) {
                · ет. {{ l.floor }}
              }
              @if (l.isNew) {
                <span class="badge under">ново</span>
              }
            </td>
            <td class="num strong">
              {{ l.priceEur | eur }}
              <div class="sub-price">{{ l.priceEur | bgn }}</div>
            </td>
            <td class="num">{{ l.priceEurPerM2 | bgInt }}</td>
            <td class="num">{{ l.areaM2 | bgInt }} м²</td>
            <td class="num">{{ l.domDays | bgInt }} дни</td>
            <td class="num">
              @if (l.discountPct; as d) {
                <span class="badge reduced">−{{ d | bg1 }}%</span>
              } @else {
                <span class="muted">–</span>
              }
            </td>
            <td class="num">
              @if (l.overpricedPct !== null) {
                <span class="badge" [class.over]="l.overpricedPct! > 5" [class.under]="l.overpricedPct! < -5">
                  {{ l.overpricedPct | pct }}
                </span>
              } @else {
                <span class="muted">–</span>
              }
            </td>
            <td>{{ statusBg[l.currentStatus] }} · {{ typeSaleBg[l.listingType] }}</td>
            <td class="num muted">{{ fmtDateBg(l.firstSeenDate) }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>

  <div class="pager">
    <button class="btn" [disabled]="r.page <= 1" (click)="page.set(r.page - 1)">← Назад</button>
    <span>стр. {{ r.page }} / {{ totalPages() }}</span>
    <button class="btn" [disabled]="r.page >= totalPages()" (click)="page.set(r.page + 1)">Напред →</button>
  </div>
} @else {
  <p class="loading">Зареждане на обявите…</p>
}
